import {isNullOrUndefined} from 'util';
import {Component, Input, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {ReferralService} from '../service/referral.service';
import {Keys, StorageService} from '../service/storage.service';
import {VerificationState} from '../model/verification-state.model';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {PartnerService} from '../service/partner.service';

@Component({
    selector: 'app-referral-input',
    templateUrl: './referral-input.component.html',
    styleUrls: ['./referral-input.component.css'],
    providers: [ReferralService, ApiServiceService, PartnerService]
})

export class ReferralInputComponent implements OnInit {

    @Input()
    isDisabled: boolean;

    isLoadingComplete = false;
    referralCode: string;
    caption = 'referral';
    VerificationState = VerificationState;
    verificationState = VerificationState.NA;

    constructor(private referralService: ReferralService, protected storageService: StorageService, public analyticsTracker: AnalyticsTracker) {
    }

    async ngOnInit() {
        this.showLoader();
        try {
            const preservedCode = this.storageService.getObjectFromSession<string>(Keys.REFERRER_CODE);

            if (!isNullOrUndefined(preservedCode)) {
                this.caption = 'partner';
                this.referralCode = preservedCode;
                await this.verifyReferralCode();
            } else {
                this.verificationState = this.storageService.getObjectFromSession<VerificationState>(Keys.VERIFICATION_STATE);
            }

            const token = this.storageService.getItem(Keys.TOKEN);
            if (!isNullOrUndefined(token)) {
                this.fetchAndRefreshCode(token);
            }
        } finally {
            this.hideLoader();
        }
    }

    async verifyReferralCode(): Promise<VerificationState> {
        this.verificationState = VerificationState.IN_PROGRESS;
        const validCodePattern = this.getRegExp();
        const trimmedCode = this.referralCode ? this.referralCode.trim() : undefined;

        if (isNullOrUndefined(trimmedCode) || trimmedCode.length === 0) {
            this.verificationState = VerificationState.NA;
            this.storageService.removeObjectFromSession(Keys.REFERRER_CODE);
            this.storageService.removeObjectFromSession(Keys.VERIFICATION_STATE);
            return this.verificationState;
        } else if (!validCodePattern.test(trimmedCode)) {
            this.verificationState = VerificationState.FAILED;
            return this.verificationState;
        } else {
            return this.remoteVerify(trimmedCode);
        }
    }

    public isCodeVerified(): boolean {
        return this.verificationState === VerificationState.VERIFIED;
    }

    private getRegExp() {
        return new RegExp('^[a-zA-Z0-9]{4,10}$');
    }

    private async remoteVerify(trimmedCode: string): Promise<VerificationState> {
        const isReferralCodeValid = await this.referralService.verifyReferralCode(trimmedCode);
        this.verificationState = isReferralCodeValid ? VerificationState.VERIFIED : VerificationState.FAILED;

        if (this.verificationState === VerificationState.VERIFIED) {
            this.storageService.saveObjectToSession(Keys.REFERRER_CODE, trimmedCode);
            this.storageService.saveObjectToSession(Keys.VERIFICATION_STATE, VerificationState.VERIFIED);
        }

        return this.verificationState;
    }

    protected async fetchAndRefreshCode(token: string): Promise<void> {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const referralDetails = await this.referralService.fetchReferralDetails(profileId, token);

        if (!isNullOrUndefined(referralDetails.referredBy.code)) {
            this.referralCode = referralDetails.referredBy.code;
            this.verificationState = VerificationState.VERIFIED;
        }
    }

    showLoader(): void {
        this.isLoadingComplete = false;
    }

    hideLoader(): void {
        this.isLoadingComplete = true;
    }
}
